import { createIcon } from '../createIcon.tsx';

export const RulerIcon = createIcon(
	'RulerIcon',
	<>
		<path d="M21.3 8.7 15.3 2.7a1 1 0 0 0-1.4 0L2.7 13.9a1 1 0 0 0 0 1.4l6 6a1 1 0 0 0 1.4 0l11.2-11.2a1 1 0 0 0 0-1.4z" />
		<path d="m7 14 2 2" />
		<path d="m10 11 2 2" />
		<path d="m13 8 2 2" />
	</>,
);
